import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { UcThemeContext } from '../../lib/UcThemeProvider';
import { UrlHelpers } from '../../lib/Helpers';
import { ApiClient } from '../../lib/ApiClient';
import { useAuthenticated } from '../auth/useAuthenticated'
import axios from 'axios';
import { getUrl, useDomainNavigate } from '../../domain';

const apiClient = new ApiClient();

export default function ImpersonateSignOut() {
    const params = new URLSearchParams(window.location.search);
    const returnUrl = getUrl(decodeURI(getUrl(UrlHelpers.getSafeUrl(params.get('returnUrl') || ""), getUrl("/account/logout"))));
    const actorEmail = decodeURI(params.get('actorEmail'));
    let navigate = useDomainNavigate();

    const userAuth = useAuthenticated(apiClient);
    const [isLoading, setIsLoading] = React.useState(true);
    // eslint-disable-next-line no-unused-vars
    const [themeState, themeDispatch] = React.useContext(UcThemeContext);

    if (!userAuth.isAuthenticating && !userAuth.isAuthenticated) {
        navigate("/account/login");
    }

    React.useEffect(() => {
        if (userAuth.isAuthenticated) {
            axios.post(getUrl(`/identity/impersonateAccount/logout?actorEmail=${actorEmail}`))
                .then(response => {
                    window.location = returnUrl;
                })
                .catch(error => {
                    console.error(error);
                    setIsLoading(false);
                });
        }
    }, [isLoading, setIsLoading, userAuth, actorEmail, returnUrl]);

    return (
        <>
            {isLoading &&
                <div className="loading-container">
                    Stopping Impersonation...
                </div>
            }
            {!isLoading && (
                <Box
                    sx={{
                        marginTop: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}
                >
                    <Alert severity="error" sx={{ mt: 2 }}>
                        <Typography variant="p" gutterBottom component="div">
                            An error has occurred while attempting to stop impersonating user.
                        </Typography>
                    </Alert>
                </Box>
            )}
        </>
    );
}